import React, { useState, useEffect, useRef } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { useNavigate, useLocation, Link } from "react-router-dom";
import "../styles/productos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../img/logoAmnorte.png";
import corteLaserImg from "../img/laser.png";
import corteTuboImg from "../img/corte_recto.png";
import doblezImg from "../img/dobladora-lamina.png";
import dobleztuboImg from "../img/dobladora-tubo.JPG";

// Actualizamos los links del submenú Servicios con hash:
const menuItems = [
  { name: "Inicio", link: "/" },
  { name: "Nosotros", link: "/nosotros" },
  {
    name: "Productos",
    link: "/productos",
    dropdown: [
      { name: "Tubería Redonda", link: "/tuberia-redonda" },
      { name: "Tubería Redonda-Cédulas", link: "/tuberia-cedulas" },
      { name: "Tubo Cerquero", link: "/tubo-cerquero" },
      { name: "Tubería Cuadrada", link: "/tuberia-cuadrada" },
      { name: "PTR y Perfiles Rectangulares", link: "/ptr" },
      { name: "Perfiles Puerta", link: "/perfil-puerta" },
      { name: "Perfiles Ventana", link: "/perfil-ventana" },
      { name: "Ángulos y Soleras", link: "/angulos-soleras" },
      { name: "Lámina R-101", link: "/lamina-R-101" },
    ],
  },
  {
    name: "Servicios",
    link: "/servicio",
    dropdown: [
      { name: "Corte Láser", link: "/servicio#corte_laser" },
      { name: "Corte de Tubo", link: "/servicio#corte_tubo" },
      { name: "Doblez", link: "/servicio#doblez" },
      { name: "Doblez de Tubo", link: "/servicio#doblez-tubo" },
    ],
  },
  { name: "Contácto", link: "/contacto" },
];

const NavBar = () => {
  const navigate = useNavigate();
  const [navbarColor, setNavbarColor] = useState("#354a66");

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const carouselElement = document.getElementById("main-carousel");
      const carouselHeight = carouselElement ? carouselElement.clientHeight : 500;

      if (scrollY < carouselHeight / 2) {
        setNavbarColor("#354a66");
      } else {
        setNavbarColor("#354a66");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar expand="lg" style={{ background: navbarColor, transition: "background 0.3s ease-in-out" }} fixed="top" className="navbar-custom">
      <Container>
        <Navbar.Brand as={Link} to="/" style={{ color: "#fff" }}>
          <img src={logo} alt="Logo Aceros y Metales" height="50" className="me-2" />
          <span>Aceros y Metales</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarNav" />
        <Navbar.Collapse id="navbarNav">
          <Nav className="ms-auto">
            {menuItems.map((item, index) =>
              item.dropdown ? (
                <NavDropdown key={index} title={item.name} id={`dropdown-${index}`} style={{ color: "#fff" }}>
                  {item.link && (
                    <NavDropdown.Item onClick={() => navigate(item.link)} style={{ color: "#fff", fontWeight: "bold" }}>
                      {item.name}
                    </NavDropdown.Item>
                  )}
                  <NavDropdown.Divider />
                  {item.dropdown.map((subItem, subIndex) => (
                    <NavDropdown.Item
                      as={Link}
                      to={subItem.link}
                      key={subIndex}
                      style={{ color: "#fff" }}
                    >
                      {subItem.name}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
              ) : (
                <Nav.Link as={Link} to={item.link} key={index} style={{ color: "#fff", transition: "color 0.3s ease" }}>
                  {item.name}
                </Nav.Link>
              )
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

const servicio = [
  {
    id: "corte_laser",
    title: "Corte Láser",
    description: "Ofrecemos corte láser con una precisión de hasta 1'', garantizando resultados perfectos y acabados de calidad para tus proyectos.",
    image: corteLaserImg,
  },
  {
    id: "corte_tubo",
    title: "Corte de Tubo",
    description: "Realizamos cortes de tubo con una gran precisión, ofreciendo tanto corte recto como corte a grados. Nos aseguramos de que cada corte se ajuste perfectamente a las necesidades de tu proyecto.",
    image: corteTuboImg,
  },
  {
    id: "doblez",
    title: "Doblez de Lámina",
    description: "Contamos con doblado de lámina de alta precisión, adaptándonos a las especificaciones de cada proyecto. Garantizamos ángulos y formas exactas, sin afectar la integridad del material.",
    image: doblezImg,
  },
  {
    id: "doblez-tubo",
    title: "Doblez de Tubo",
    description: "En Aymnorte ofrecemos servicio de doblez de tubo con precisión y calidad, utilizando nuestra dobladora de tubo para adaptarnos a tus necesidades. Realizamos dobleces en distintos ángulos y diámetros, garantizando acabados limpios y sin deformaciones. Ideal para estructuras metálicas, barandales, mobiliario y más",
    image: dobleztuboImg,
  },
];

const Servicio = () => {
  const [visibleSections, setVisibleSections] = useState([]);
  const sectionRefs = useRef([]);
  const location = useLocation();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections((prev) => [...new Set([...prev, entry.target.id])]);
          } else {
            setVisibleSections((prev) => prev.filter((id) => id !== entry.target.id));
          }
        });
      },
      { threshold: 0.5 }
    );

    sectionRefs.current.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  // Scroll hacia el ancla/hash
  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          const yOffset = -100; // para compensar el navbar fijo
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        }, 300);
      }
    }
  }, [location]);

  return (
    <div>
      <div className="servicios-container" style={{ textAlign: "center", marginBottom: "30px" }}>
        <div
          className="servicios-title"
          style={{
            marginTop: "130px",
            fontSize: "3rem",
            fontWeight: "bold",
            color: "#f58634",
            textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
            padding: "10px",
            animation: "fadeIn 1s ease-in-out",
            textAlign: "center",
          }}
        >
          Servicios
        </div>
      </div>

      {servicio.map((servicio, index) => (
        <section
          key={servicio.id}
          ref={(el) => (sectionRefs.current[index] = el)}
          id={servicio.id}
          className={`full-width-section service ${visibleSections.includes(servicio.id) ? "visible" : ""}`}
          style={{
            backgroundImage: `url(${servicio.image})`,
            width: "100%",
            height: "100vh",
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: index % 2 === 0 ? "flex-start" : "flex-end",
            opacity: visibleSections.includes(servicio.id) ? 1 : 0,
            transform: visibleSections.includes(servicio.id) ? "translateY(0)" : "translateY(30px)",
            transition: "all 1s ease-out",
          }}
        >
          <div
            className="service-overlay"
            style={{
              width: "50%",
              height: "100%",
              backgroundColor: "rgba(245, 132, 52, 0.6)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              color: "white",
              textAlign: "center",
              padding: "20px",
              opacity: visibleSections.includes(servicio.id) ? 1 : 0,
              transform: visibleSections.includes(servicio.id) ? "translateY(0)" : "translateY(30px)",
              transition: "all 1s ease-out",
            }}
          >
            <h1>{servicio.title}</h1>
            <p>{servicio.description}</p>
          </div>
        </section>
      ))}

      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .service {
            opacity: 0;
            transition: opacity 1s ease-in-out, transform 1s ease-out;
          }

          .service.visible {
            opacity: 1;
            transform: translateY(0);
          }
        `}
      </style>
    </div>
  );
};

const Productos = () => (
  <section className="nproductos text-center my-5">
    <h3>Nuestros Productos</h3>
    <div className="productos-container">
      <Link to='/tuberia-redonda' style={{ textDecoration: 'none' }}>
        <div className="producto"><p>Tubería Redonda</p><img src={require("../img/tuberia_redonda.JPG")} alt="Tubería Redonda" /></div>
      </Link>
      <Link to='/tuberia-cedulas' style={{ textDecoration: 'none' }}>
        <div className="producto"><p>Tubería Cédulas</p><img src={require("../img/tuberia_cedulas.JPG")} alt="Tubería Cédulas" /></div>
      </Link>
      <Link to='/tubo-cerquero' style={{ textDecoration: 'none' }}>
        <div className="producto"><p>Tubo Cerquero</p><img src={require("../img/tubo_cerquero.png")} alt="Tubo Cerquero" /></div>
      </Link>
      <Link to='/tuberia-cuadrada' style={{ textDecoration: 'none' }}>
        <div className="producto"><p>Tubería Cuadrada</p><img src={require("../img/tuberia_cuadrada.png")} alt="Tubería Cuadrada" /></div>
      </Link>
      <Link to='/ptr' style={{ textDecoration: 'none' }}>
        <div className="producto"><p style={{ fontSize: '13px' }}>PTR y Rectangulares</p><img src={require("../img/ptr.png")} alt="PTR" /></div>
      </Link>
      <Link to='/perfiles' style={{ textDecoration: 'none' }}>
        <div className="producto"><p>Perfiles</p><img src={require("../img/p-puerta-verde.png")} alt="Perfiles" /></div>
      </Link>
      <Link to='/lamina-R-101' style={{ textDecoration: 'none' }}>
        <div className="producto"><p>Lámina</p><img src={require("../img/Lamina.png")} alt="Lámina R-101" /></div>
      </Link>
    </div>
  </section>
);

const WhatsAppButton = () => (
  <a href="https://wa.me/525547829794" target="_blank" rel="noopener noreferrer" className="whatsapp-button">
    <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" style={{ width: "60px", height: "60px" }} />
  </a>
);

const Footer = () => (
  <footer className="footer">
    <div className="container fluid">
      <div className="row d-flex align-items-stretch">
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="contact-info text-center" style={{ textAlign: "justify" }}>
            <h5>CONTÁCTANOS</h5>
            <p style={{ color: "#fff" }}><strong>Email:</strong> contacto@aymnorte.com.mx</p>
            <p style={{ color: "#fff" }}><strong>Teléfono:</strong> +52 55 4782 9794</p>
          </div>
        </div>
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="address text-center" style={{ textAlign: "justify" }}>
            <h5>CORPORATIVO</h5>
            <p>Calzada Mariano Escobedo #476,<br />Piso 12 Int. 1200 B, Anzures,<br />Miguel Hidalgo, Ciudad de México, C.P. 11590</p>
          </div>
        </div>
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="address text-center" style={{ textAlign: "justify" }}>
            <h5>CEDIS</h5>
            <p>Carretera Federal México-Querétaro KM 100,<br />San Miguel de la Victoria, Jilotepec,<br />Estado de México, C.P. 54270</p>
          </div>
        </div>
      </div>
      <div className="row text-center">
        <div className="col-md-12">
          <p style={{ color: "#fff" }}>AMNorte Aceros y Metales &copy; 2025 - Todos los derechos reservados</p>
          <p>
            <Link to='/Avisos_Privacidad'>
              <a style={{ color: "white", textDecoration: "none" }}>Aviso de Privacidad |</a>
            </Link>
            <Link to='/Terminos_y_Condiciones'>
              <a style={{ color: "white", textDecoration: "none" }}> Términos y Condiciones</a>
            </Link>
          </p>
        </div>
      </div>
    </div>
  </footer>
);

const Servicios = () => {
  return (
    <div>
      <NavBar />
      <Servicio />
      <Productos />
      <WhatsAppButton />
      <Footer />
    </div>
  );
};

export default Servicios;
